import React, { useState, useEffect } from 'react';
import ReportList from './ReportList';

import './CustomCreateMain.css';
import CustomCreateInformation from './CustomCreateInformation';

const CustomCreateMain = (props) => {
  const [reportLabelData, setReportLabelData] = useState();

  useEffect(()=>{
    setReportLabelData(props.reportLabelData);
  }, [props.reportLabelData]);

  return (
    <div className="row featured-main">
      <div className="manageReportBoxLR">
        <table width="100%" border="0" cellspacing="0" cellpadding="0">
          <tr>
            <td width="22%" valign="top">
                {reportLabelData &&
                  <div id="manageReportLeft">
                    <ReportList handleClick={props.handleSelectedReport} reportLabelData={reportLabelData}
                      handleSearchBtn={props.handleSearchBtn} reportFilter={props.reportFilter} handleSearchInput={props.handleSearchInput} filteredArray={props.filteredArray}
                    />
                  </div>
                }
            </td>
            <td width="78%" valign="top">
              <div id="manageReportRight">
                <CustomCreateInformation 
                  handleSaveBtn={props.handleSaveBtn} handleRemoveBtn={props.handleRemoveBtn} handleResetBtn={props.handleResetBtn}
                  selectedReportArray={props.selectedReportArray} selectedReportQueryArray={props.selectedReportQueryArray} queryData={props.queryData}
                  userLabelData={props.userLabelData}
                // reportInfo={selectedReport} queryData={queryData} selectedReportQuery={selectedReportQuery}
                // handleRemoveBtn={props.handleRemoveBtn} handleRunBtn={props.handleRunBtn}
                />
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>

  )
}

export default CustomCreateMain;